import { apiCall } from 'src/utils/ApiCall';
import { GetGLExportsOutput } from '@amzn/controllershiphub-typescript-client';

export const getGLExports = async (controlId: string): Promise<GetGLExportsOutput> => {
  const response = await apiCall({
    endpoint: `/GetGLExports/${controlId}`,
    method: 'GET',
  });

  return response as GetGLExportsOutput;
};
